import React from "react";
import LoanTable from "../sections/LoanTable.jsx";
import PrimaryPageContainer from "../components/containers/PrimaryPageContainer.jsx";

function HomePage() {
  return (
    <PrimaryPageContainer>
      <LoanTable />
    </PrimaryPageContainer>
  );
}

export default HomePage;
